<template>
	<div class="full_mark_box" v-if="isShow_fullmark">
		<div id="submitquestionpop_wrap" v-if="isShow_submitquestionpop">
			<div class="submitquestionpop_wrap_top">
				<span id="sub_t" style="float: left;display: block;color: #3A3A3C;">提问</span>
				<span id="sub_x" style="float: right;display: block;color: #AAAAAA;cursor: pointer;" @click="closesubmitquestionpop" title="点击关闭"><i class="el-icon-close"></i></span>
			</div>
			<div class="submitquestionpop_wrap_main">
				<div class="maincontent">
					<textarea class="maincontent_1" placeholder="请输入您的问题" v-model="content">
						
					</textarea>
				</div>
				<div class="question_submit" @click="submitquestionpop">
					提交
				</div>
			</div>
		</div>

		<!--
        	作者：1272109752@qq.com
        	时间：2018-10-29
        	描述：questionpop
        -->
		<div id="questionpop_wrap" v-if="isShow_questionpop">
			<div class="questionpop_wrap_top">
				<span id="submitquestion_t" style="float: left;display: block;color: #3A3A3C;">提示</span>
				<span id="submitquestion_c" style="float: right;display: block;color: #AAAAAA;cursor: pointer;" @click="closesubmitquestionpop" title="点击关闭"><i class="el-icon-close"></i></span>
			</div>
			<div class="questionpop_wrap_main">
				<div class="maincontent">
					<div class="p_container">
							您的问题已提交，DataGalaxy团队将在1~3个工作日内回复，
							您可在
							<a style="color:#347AD8 ;cursor: pointer;"@click="gomyquestion">
							个人中心—我的提问
							</a>
							中查看回复。感谢您的支持！
					</div>
				</div>
				<div class="maincontent">
					若为紧急问题建议您加
						<a style="color: #347AD8;">技术交流QQ群：747279799</a>
					
				</div>
				<div class="question_submit_finish" @click="closesubmitsuccesspop">
					好的
				</div>
			</div>
		</div>

	</div>

</template>

<script>
	//	import questionpop from '@/messageBox/questionpop.vue'
	export default {
		data() {
			return {
				isShow_fullmark: false,
				isShow_submitquestionpop: false,
				isShow_questionpop: false,
				
				problemType:'',		//提问类型
				problemTarget:'',		//提问对象
				content:'',			//提问内容
			}
		},
		components: {
			//			questionpop
		},
		methods: {
			// 打开提交问题弹窗
			opensubmitquestionpop(type,target) {
				
				this.problemType = type;	//提问类型
				this.problemTarget = target;	//提问uuid
				
				this.isShow_fullmark = true;
				this.isShow_submitquestionpop = true;
			},
			//关闭提交问题弹窗
			closesubmitquestionpop() {
				this.isShow_submitquestionpop = false;
				this.isShow_fullmark = false
			},
			
			//提交问题
			submitquestionpop() {
				let _this=this;
				//判断用户是否提交了问题
				if(this.content == ''){
					this.$message({
								message: '请输入您的问题',
								type: 'warning',
								dangerouslyUseHTMLString:true,
								customClass: 'message-warning',
							});
							return;
				}
				
				this.$http.post(
				  	_this.apiUrl+"index.php?m=Api&c=user&a=questions_create",
					{
						userCode:sessionStorage.getItem('usercode'),
						type:this.problemType,
						target:this.problemTarget,
						content:this.content
					},
					{emulateJSON: true}
				).then(
					(response)=>{
				
						//判断是否提问成功
						if(response.body.status == 1){
							sessionStorage.setItem('isRefresh',true);
							this.isShow_submitquestionpop = false;
							this.isShow_questionpop = true;
							this.content = '';
						}else{
//							alert(response.body.massage);
						}	
				     
				        
				    },
				    (error)=>{}
				);
				
			},
			opensubmitsuccesspop() {
				var that = this;
				that.isShow_questionpop = true;
			},
			closesubmitsuccesspop() {
				var that = this;
				that.isShow_questionpop = false;
				that.isShow_fullmark = false
			},
			gomyquestion() {
				// this.$router.push('/usercenter')
				this.$router.push({
					path: '/usercenter',
					query: {
						type: 'problem'
					}
				})
			}
		}
	}
</script>

<style>
	#sub_t{
		height: 40px;
		line-height: 40px;
		font-size: 18px;
	}
	#sub_x{
		height: 40px;
		line-height: 40px;
		font-size: 24px;
	}
	.full_mark_box {
		width: 100%;
		height: 100%;
		position: fixed;
		left: 0;
		top: 0;
		z-index: 999;
		background: rgba(0, 0, 0, .5);
	}
	
	#submitquestionpop_wrap{
		background: white;
		position: fixed;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		margin: auto;
		width: 514px;
		height: 300px;
		border-radius: 5px;
	}
	#reset_password_wrap {
		background: white;
		position: fixed;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		margin: auto;
		width: 514px;
		height: 350px;
		border-radius: 5px;
	}
	
	#submitquestionpop_wrap .submitquestionpop_wrap_top {
		border-radius: 5px 5px 0 0;
		padding: 0 20px;
		height: 40px;
		background: #F3F7F9;
		width: 474px;
	}
	
	#submitquestionpop_wrap .submitquestionpop_wrap_main {
		width: 460px;
		margin: 0 auto;
		margin-top: 30px;
	}
	#submitquestionpop_wrap .submitquestionpop_wrap_main .maincontent {
		width: 460px;
		height: 150px;
		font-size: 16px;
	}
	
	.submitquestionpop_wrap_main .maincontent>textarea {
		border-radius: 4px;
		width: 460px;
		height: 130px;
		border: 1px solid #999999;
		text-align: left;
		line-height: 24px;
		font-size: 16px;
		resize: none;
	}
	
	.submitquestionpop_wrap_main .maincontent span {
		width: 460px;
		height: 20px;
		font-size: 16px;
		line-height: 20px;
		color: red;
	}
	
	.submitquestionpop_wrap_main .contact_way {
		height: 67px;
		width: 460px;
		line-height: 0;
	}
	
	.submitquestionpop_wrap_main .contact_way>input {
		height: 40px;
		width: 460px;
		line-height: 40px;
		text-indent: 2em;
	}
	
	.question_submit {
		cursor: pointer;
		display: block;
		height: 40px;
		line-height: 40px;
		background: #076bf2;
	    color: white;
		border-radius: 20px;
		font-size: 16px;
		width: 160px;
		margin: 20px auto;
	}
	
	.maincontent_1 {
		width: 460px;
		height: 150px;
		border: 2px solid #F3F3F3;
		border-radius: 5px;
		text-align: left;
		resize: none;
	}
	
	#questionpop_wrap,
	#reset_password_wrap {
		background: white;
		position: fixed;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		margin: auto;
		width: 514px;
		height: 350px;
		border-radius: 5px;
		z-index: 9999;
	}
	
	#questionpop_wrap .questionpop_wrap_top {
		border-radius: 5px 5px 0 0;
		padding: 0 20px;
		height: 40px;
		background: #F3F7F9;
		width: 474px;
	}
	
	#questionpop_wrap .questionpop_wrap_main {
		width: 460px;
		margin: 0 auto;
		margin-top: 30px;
	}
	
	#questionpop_wrap .questionpop_wrap_main .maincontent {
		width: 410px;
		height: 47.5px;
		font-size: 16px;
		text-align: left;
		padding-top: 40px;
		margin: 0 auto;
	}
	
	#questionpop_wrap .questionpop_wrap_main .maincontent span {
		width: 400px;
		height: 20px;
		font-size: 16px;
		line-height: 20px;
		color: red;
	}
	.p_container{
		text-align: left;
	}
	#questionpop_wrap .questionpop_wrap_main .maincontent .p_left{
		text-align: left;
	}
	#questionpop_wrap .questionpop_wrap_main .contact_way {
		height: 67px;
		width: 460px;
		line-height: 0;
	}
	
	#questionpop_wrap .questionpop_wrap_main .contact_way>input {
		height: 40px;
		width: 460px;
		line-height: 40px;
		text-indent: 2em;
		size: ;
	}
	
	#questionpop_wrap .question_submit_finish {
		display: block;
		height: 40px;
		line-height: 40px;
		background: #076bf2;
		cursor: pointer;
	    color: white;
		border-radius: 20px;
		font-size: 16px;
		width: 160px;
		margin: 20px auto;
	}
	#submitquestion_t{
		height: 40px;
		line-height: 40px;
		font-size: 18px;
	}
	#submitquestion_c{
		height: 40px;
		line-height: 40px;
		font-size: 24px;
	}
</style>


// WEBPACK FOOTER //
// src/messageBox/submitquestionpop.vue